<template>
    <div class="relative max-mob:w-full w-105 h-full flex flex-col items-center">
        <TickGradientIcon64x64 />

        <div
            v-if="!isAccountTrialEnded"
            class="absolute top-0 right-0"
        >
            <CloseIconMini
                class="text-gray-200 cursor-pointer"
                @click="close"
            />
        </div>

        <div class="pt-6 mb-3 text-xxxl max-mob:text-xl text-center text-gray-370 dark:text-white">
            <div>Thank you!</div>

            <div>Your data has been received</div>
        </div>

        <div class="mb-8 text-sm max-mob:text-xs text-center text-gray-200">
            Your documents have been successfully submitted <br class="max-mob:hidden"/>
            and are currently under review. <br class="max-mob:hidden"/>
            Verification typically takes up to 3 business days. <br class="max-mob:hidden"/>
            You’ll receive a notification once it’s complete
        </div>

        <div class="pb-6 w-full max-w-82 grid divide-y divide-white-500 dark:divide-gray-760">
            <ReviewListItem
                v-for="item in Object.values(VERIFICATION_MINI_STEPS)"
                :key="item.id"
                :item="item"
            />
        </div>

        <div class="pt-4 w-full border-t border-white-500 dark:border-gray-760">
            <div
                v-if="isAccountTrialEnded"
                class="flex justify-center"
            >
                <LogoutButton  />
            </div>

            <div
                v-else
                class="w-full flex justify-end gap-x-5"
            >
                <TextBtn
                    @click="close"
                >
                    Cancel
                </TextBtn>

                <PrimaryBtn @click="close">
                    Explore the Platform
                </PrimaryBtn>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'

import LogoutButton from '@/components/buttons/LogoutButton.vue'
import TickGradientIcon64x64 from '@/components/icons/tick/TickGradientIcon64x64.vue'
import ReviewListItem from '@/views/verification/list/ReviewListItem.vue'
import CloseIconMini from '@/components/icons/CloseIconMini.vue'
import TextBtn from '@/components/buttons/TextBtn.vue'
import PrimaryBtn from '@/components/buttons/PrimaryBtn.vue'

import { useAuthorizationStore } from '@/store/authorizationStore'

import { VERIFICATION_MINI_STEPS } from '@/constants/verification'

const emits = defineEmits(['close'])

const authorizationStore = useAuthorizationStore()

const isAccountTrialEnded = computed(() => authorizationStore.isAccountTrialEnded)

function close() {
    emits('close')
}
</script>
